import {useState , useContext, createContext } from "react";
import SummaryApi from "../common";
import { toast } from "react-toastify";
export const BankContext = createContext();

const BankContextProvider = ({children}) =>{
    const [bank,setBank] = useState(null);
    const [isBankLoading,setBankLoading] = useState(true);

    const addBank = async(bankData) =>{
        const response = await fetch(SummaryApi.addBank.url,{
            method:SummaryApi.addBank.method,
            headers:{
                "Content-Type": "application/json",
                 Authorization: `Bearer ${localStorage.getItem("authToken")}`,
           },
           body: JSON.stringify(bankData)
        })

        const data = await response.json();
        if(!response.ok){
            console.log('failed adding bank');
            toast.error(data.message);
            return;
        }
        setBank(data.bankData);
        toast.success(data.message);
    }

    const getBank = async()=>{
        setBankLoading(true);
        try{
            const response = await fetch(SummaryApi.getBank.url,{
                method: SummaryApi.getBank.method,
                headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                },
            })
    
            const data = await response.json();
            if(!response.ok){
                toast.error(data.message);
                console.log('failed to fetch data',data.message);
            }
            console.log('bank data fetched');
            setBank(data.bankData);
        }catch(err){
            toast.error('error fetching Bank');
            console.log('error in fetching Bank',err);
        }finally{
            setBankLoading(false);
        }
    }     
    
    const updateBank = async(bankData)=>{
        try{
            const response = await fetch(SummaryApi.updateBank.url,{
                method: SummaryApi.updateBank.method,
                headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                },
                body:JSON.stringify(bankData)
            })
    
            const data = await response.json();
            if(!response.ok){
                toast.error(data.message);
                console.log('failed to update data',data.message);
            }
            // console.log('bank data update',data.bankData);
            setBank((prevState)=>({...prevState,...data.bankData}));
            toast.success(data.message);
        }catch(err){
            toast.error('error updating Bank');
            console.log('error in updating Bank',err);
        }
    }
    const addMoney = async(newAmount)=>{
        try{
            const response = await fetch(SummaryApi.addMoney.url,{
                method:SummaryApi.addMoney.method,
                headers:{
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem('authToken')}`
                },
                body:JSON.stringify(newAmount)
            })
            const data = await response.json();
            if(!response.ok){
                console.log('failed to add money');
                toast.error(data.message);
            }
            // console.log(data.newBalance?.balance);
            setBank(data.newBalance);
            toast.success(data.message);
            // toast.success(data.message);
        }catch(err){
            console.log('error adding money');
        }
    }

    const spendMoney = async(newAmount)=>{
        try{
            const response = await fetch(SummaryApi.spendMoney.url,{
                method:SummaryApi.spendMoney.method,
                headers:{
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem('authToken')}`
                },
                body:JSON.stringify(newAmount)
            })
            const data = await response.json();
            if(!response.ok){
                console.log('failed to spend money');
                toast.error(data.message);
            }
            console.log(data.newBalance?.balance);
            setBank(data.newBalance);
            toast.success(data.message);
            // toast.success(data.message);
        }catch(err){
            console.log('error spend money');
        }        
    }
    return (
        <BankContext.Provider value={{isBankLoading,bank,addBank,getBank,updateBank,addMoney,spendMoney}}>
            {children}
        </BankContext.Provider>
    )
}
export default BankContextProvider;